import Vue from "vue";

Vue.filter("humanDate", function(date){
  const timeZone = 'America/Sao_Paulo'; // Brazilian time zone
  const options = { timeZone, year: 'numeric', month: 'numeric', day: 'numeric' };

  let dateObj = new Date(date);
  return dateObj.toLocaleDateString('pt-BR', options)
});

Vue.filter("humanDateTime", function(date){
  let dateObj = new Date(date);
  return dateObj.toLocaleDateString('pt-BR') + ' ' + dateObj.toLocaleTimeString('pt-BR')
});

Vue.filter("currency", function(number){
  return (number || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl', minimumFractionDigits: 2, maximumFractionDigits: 2})
});

Vue.filter("number", function(number, options={}){
  return (number || 0).toLocaleString('pt-BR', options);
});
